import { DiGraph } from "../../graph/digraph.js";

/** Annex II Field 1 DAG. “A → B” means B builds on A. */
const EDGES: readonly [string, string][] = [
  ["enterprise_ai_architecture", "model_selection_eval"],
  ["enterprise_ai_architecture", "data_pipelines_quality"],
  ["enterprise_ai_architecture", "act_scope_roles"],
  ["model_selection_eval", "mlops_lifecycle"],
  ["data_pipelines_quality", "mlops_lifecycle"],
  ["mlops_lifecycle", "generative_rag"],
  ["mlops_lifecycle", "trustworthiness_eval"],
  ["generative_rag", "agents_mcp"],
  ["agents_mcp", "trustworthiness_eval"],
  ["act_scope_roles", "act_prohibited"],
  ["act_scope_roles", "act_high_risk"],
  ["act_scope_roles", "gpai_transparency"],
  ["act_prohibited", "act_high_risk"],
  ["act_high_risk", "act_obligations_ops"],
  ["act_high_risk", "gpai_transparency"],
  ["act_obligations_ops", "trustworthiness_eval"],
  ["act_obligations_ops", "ai_office_enforcement"],
  ["gpai_transparency", "ai_office_enforcement"],
  ["gpai_transparency", "policy_watch_impact"],
  ["ai_office_enforcement", "policy_watch_impact"],
];

export const EPSO_AD8_AI_NODE_IDS: readonly string[] = [
  "enterprise_ai_architecture",
  "model_selection_eval",
  "data_pipelines_quality",
  "mlops_lifecycle",
  "generative_rag",
  "agents_mcp",
  "act_scope_roles",
  "act_prohibited",
  "act_high_risk",
  "act_obligations_ops",
  "gpai_transparency",
  "trustworthiness_eval",
  "ai_office_enforcement",
  "policy_watch_impact",
];

export function buildEpsoAd8AiGraph(): DiGraph {
  const g = new DiGraph();
  for (const [a, b] of EDGES) {
    g.addEdge(a, b, 1);
  }
  for (const id of EPSO_AD8_AI_NODE_IDS) {
    g.addNode(id);
  }
  return g;
}
